import axios from 'axios'

export default {
  namespaced: true,
  state: {
    menu: []
  },

  mutations: {
    SET_MENU (state, data) {
      state.menu = data
    }
  },

  getters: {},

  actions: {
    async get ({ commit }) {
      let data = await axios.get('/settings/menu')
      commit('SET_MENU', data.data)
      console.log(data)
    },

    async update ({ commit }, { id, data }) {
      return axios.patch(`/settings/menu/${id}`, { data })
    }
  }
}
